
import { application } from "./application"

import ModalController from "./modal_controller"
import DismissableController from "./dismissable_controller"
import SearchController from "./search_controller"
import DropdownController from "./dropdown_controller"
import DocumentPrintController from "./document_print_controller"
import FormController from "./form_controller"
import AutosaveController from "./autosave_controller"
import BarcodeGeneratorController from "./barcode_generator_controller"
import AutogrowController from "./autogrow_controller"
import ConditionalVisibilityController from "./conditional_visibility_controller"
import ClickableRowController from "./clickable_row_controller"
import FlashController from "./flash_controller"
import FileInputController from "./file_input_controller"
import FlatpickrController from "./flatpickr_controller"
import FiscalReceiptController from "./fiscal_receipt_controller"
import KkmController from "./kkm_controller"
import PhoneInputController from "./phone_input_controller"
import SidebarController from "./sidebar_controller"
import SelectController from "./select_controller"
import StockDocumentItemsController from "./stock_document_items_controller"
import SupplierSelectController from "./supplier_select_controller"
import CustomerSelectController from "./customer_select_controller"
import TomSelectController from "./tom_select_controller"
import RetailOrderController from "./retail_order_controller"
import RetailQuickSaleController from "./retail_quick_sale_controller"
import SortableController from "./sortable_controller"
import PasswordVisibility from "@stimulus-components/password-visibility"
import DemoModal from "./demo_modal_controller";

application.register("modal", ModalController)
application.register("dismissable", DismissableController)
application.register("search", SearchController)
application.register("dropdown", DropdownController)
application.register("document-print", DocumentPrintController)
application.register("form", FormController)
application.register("autosave", AutosaveController)
application.register("barcode-generator", BarcodeGeneratorController)
application.register("autogrow", AutogrowController)
application.register("conditional-visibility", ConditionalVisibilityController)
application.register("clickable-row", ClickableRowController)
application.register("flash", FlashController)
application.register("file-input", FileInputController)
application.register("flatpickr", FlatpickrController)
application.register("fiscal-receipt", FiscalReceiptController)
application.register("kkm", KkmController)
application.register("phone-input", PhoneInputController)
application.register("sidebar", SidebarController)
application.register("select", SelectController)
application.register("stock-document-items", StockDocumentItemsController)
application.register("supplier-select", SupplierSelectController)
application.register("customer-select", CustomerSelectController)
application.register("tom-select", TomSelectController)
application.register("retail-order", RetailOrderController)
application.register("retail-quick-sale", RetailQuickSaleController)
application.register("sortable", SortableController)
application.register("password-visibility", PasswordVisibility)
application.register("demo-modal", DemoModal)
